/** @jsx jsx */
import React from 'react';
import { grayScale } from 'components/styles';
import Accordion from 'components/molecules/Accordion';
import DataTable from 'components/organismos/DataTable/DataTable';
import PrimaryButton from 'components/atoms/Button';
import { css, jsx } from '@emotion/core';
import { useApplyingTransferForm } from '../ApplyingTab/hook';
import RejectedAllowanceDomain from '../domain/rejectedAllowanceDomain';
import AllowanceChangeLogModal from '../AllowanceChangeLogModal';

const AllowanceAccordion: React.FC<{ list: RejectedAllowanceDomain[] }> = ({ list }) => {
  // 更新履歴モーダルの状態（打刻修正申請の StampAccordion と同じ hook を使う）
  const {
    allowanceChangeLogData,
    setAllowanceChangeLogData,
    changeLogModalOpen,
    setChangeLogModalOpen,
    selectChangelog,
    setSelectChangelog,
    fetchAllowanceChangeLog,
  } = useApplyingTransferForm(list);

  const columns = React.useMemo(
    () => [
      {
        Header: '否決日時',
        accessor: 'approvalDate',
      },
      {
        Header: '否決者',
        accessor: 'authorizer',
      },
      {
        Header: '組織名',
        accessor: 'orgName',
      },
      {
        Header: '申請者',
        accessor: 'applicant',
      },
      {
        Header: '申請日時',
        accessor: 'applicationDate',
      },
      {
        Header: '対象者',
        accessor: 'targetPerson',
      },
      {
        Header: '対象日付',
        accessor: 'targetDate',
        // 打刻修正申請と同じ「更新履歴」ボタン（同じ組織・スタッフ・対象日の全版を版ごとに表示）
        Cell: (cell: { row: { original: RejectedAllowanceDomain } }) => (
          <div style={{ textAlign: 'center' }}>
            <div
              css={css`
                button {
                  background-color: #f0ad4e;
                  border-color: #e08e0b;
                  padding: 0.2rem;
                  line-height: 14px;
                }
              `}
            >
              <div>{cell.row.original.targetDate}</div>
              <PrimaryButton
                text="更新履歴"
                onClick={() => {
                  fetchAllowanceChangeLog(cell.row.original.modifierApplicationId);
                  setChangeLogModalOpen(true);
                  setSelectChangelog('0');
                }}
              />
            </div>
          </div>
        ),
      },
      {
        Header: '申請種別',
        accessor: 'modifiyStatusName',
      },
      {
        // 手当は単位が手当ごとに違う（円・回）ので合計は出さず、申請された手当を1行ずつ並べる
        Header: '手当',
        accessor: 'allowanceDetailText',
        Cell: (cell: { row: { original: RejectedAllowanceDomain } }) => (
          <div>
            {cell.row.original.allowanceDetailLines.map((line) => (
              <div key={line.allowanceId}>{line.text}</div>
            ))}
          </div>
        ),
      },
      {
        Header: '否決者コメント',
        accessor: 'rejectReason',
      },
    ],
    [fetchAllowanceChangeLog, setChangeLogModalOpen, setSelectChangelog],
  );

  return (
    <div
      css={css`
      table th:nth-child(1) {
        width: 140px;
      }
      table th:nth-child(2) {
        width: 140px;
      }
      table th:nth-child(3) {
        width: 140px;
      }
      table th:nth-child(4) {
        width: 140px;
      }
      table th:nth-child(5) {
        width: 140px;
      }
      table th:nth-child(6) {
        width: 140px;
      }
      table th:nth-child(7) {
        width: 80px;
      }
      table th:nth-child(8) {
        width: 80px;
      }
      /* 手当（申請された手当を1行ずつ並べるので他より広く取る） */
      table th:nth-child(9) {
        width: 240px;
      }
      table th:nth-child(10) {
        width: 100px;
      }
      table th:nth-child(11) {
        width: 200px;
      }
        `}
    >
      <Accordion
        text={`手当申請 (${list.length}件）`}
        color={grayScale.gray100}
        callBack={() => {}}
      >
        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
          <DataTable columns={columns} data={list} isGlobalFilter={true} minWidth="1624px" sortBy={[{id : 'approvalDate', desc: true}]} />
        </div>
      </Accordion>

      {/* 更新履歴 */}
      <AllowanceChangeLogModal
        open={changeLogModalOpen}
        data={allowanceChangeLogData}
        selected={selectChangelog}
        setSelected={setSelectChangelog}
        onClose={() => {
          setChangeLogModalOpen(false);
          setAllowanceChangeLogData([]);
        }}
      />
    </div>
  );
};

export default AllowanceAccordion;
